var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'main-node',class:{'node': true, 'nodeInit': _vm.node.init }},[_c('div',{staticClass:"node-content"},[_c('pre',[_vm._v(_vm._s(_vm.node.position))])])])}
var staticRenderFns = []

export { render, staticRenderFns }